import { alertIcons, getAlertTitles, IAlertTypes } from '@/data/libraries/alertTypes';
import { Container, Col, Row } from 'react-bootstrap';

import CloseIcon from '@/ui/assets/CloseIcon';
import IconList from '@/ui/components/IconList';

interface PropsCartAlertModal {
  message: string;
  type: IAlertTypes;
  onClose?: () => void;
}
const CartAlertModal = ({ message, onClose, type }: PropsCartAlertModal) => {
  const alertTitles = getAlertTitles();
  return (
    <Container fluid className='p-0 bg-primary-4 my-2 shadow rounded '>
      <Col lg={12} className='align-self-end  '>
        <div className={`bg-${type} pt-1 rounded-4 rounded-top-5`} />
      </Col>

      <Row className='mx-1'>
        <Row className='d-flex justify-content-center'>
          <Col lg={12} className='mt-2 d-flex justify-content-between'>
            <IconList classIcon='pe-2' title={alertTitles[type]} classTitle={`text-${type} p-title-bold`} iconName={alertIcons[type]} classMain={`svg-${type}`} />
            {onClose && <CloseIcon onClick={onClose} />}
          </Col>
          <Col lg={12} className='text-secondary-1 d-flex text-justify my-2'>
            {message}
          </Col>
        </Row>
      </Row>
    </Container>
  );
};

export default CartAlertModal;
